export default "__VITE_ASSET__56c946b8__"